import { Box, styled } from '@mui/material';

export const StyledTabDrawerTab = styled(Box)({
  textTransform: 'uppercase',
  padding: '5px',
  cursor: 'pointer',
  fontSize: '12px',
  borderTopLeftRadius: '4px',
  borderTopRightRadius: '4px',
  border: '1px solid #037DE8',
  minWidth: '120px',
  maxWidth: '240px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  '@media (max-width: 1200px)': {
    minWidth: '100px',
    maxWidth: '180px',
  },
  '@media (max-width: 900px)': {
    minWidth: '80px',
    maxWidth: '120px',
  },
  '@media (max-width: 600px)': {
    minWidth: '60px',
    maxWidth: '100px',
  },
});
